import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { AppContextProvider } from 'context/app-context'
import 'swiper/css/bundle'

function App() {
  return (
    <>
      <GlobalStyle />
      <AppContextProvider>
        <Home />
      </AppContextProvider>
    </>
  )
}

export default App
